"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * A light-weight pseudo form that maintains form-like concepts like focus.
         * @internal
         */
        var ProtoForm = /** @class */ (function (_super) {
            __extends(ProtoForm, _super);
            function ProtoForm(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.__protoForm = true;
                $dyn.ui.makeRoot(_this);
                return _this;
            }
            ProtoForm.prototype.init = function (data, element) {
                _super.prototype.init.call(this, data, element);
                this.trackInternalFocus();
            };
            ProtoForm.prototype.dispose = function () {
                if (this.element) {
                    $(this.element).off("focusin");
                }
                _super.prototype.dispose.call(this);
            };
            ProtoForm.prototype.takeNavigationFocus = function () {
                if (this.lastFocusedElement) {
                    $dyn.util.focusElement(this.lastFocusedElement);
                    return true;
                }
                return false;
            };
            ProtoForm.prototype.trackInternalFocus = function () {
                var _this = this;
                if (this.element) {
                    var $element = $(this.element);
                    $element.on("focusin", function (event) {
                        if (event.target) {
                            _this.lastFocusedElement = event.target;
                        }
                    });
                }
            };
            return ProtoForm;
        }($dyn.ui.Container));
        controls.ProtoForm = ProtoForm;
        ProtoForm.prototype.__protoForm = true;
        // tslint:disable-next-line:no-string-literal
        ProtoForm.prototype["lastFocusedElement"] = null;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ProtoForm.js.map
